import { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";

import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const Finance = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/reports/finance");
      setData(res.data);
    } catch (err) {
      console.error("Error loading finance report", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  if (loading || !data)
    return (
      <div className="text-center p-5 text-muted">
        <div className="spinner-border text-primary" role="status"></div>
        <p className="mt-2">Loading Financial Report...</p>
      </div>
    );

  const COLORS = ["#0d6efd", "#20c997", "#ffc107", "#dc3545", "#6f42c1"];

  return (
    <div className="finance-report container-fluid py-3">
      {/* عنوان */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold mb-0">Financial Overview</h2>
        <button className="btn btn-outline-primary btn-sm" onClick={fetchReport}>
          <i className="bi bi-arrow-clockwise me-1"></i> Refresh
        </button>
      </div>

      {/* کارت‌های خلاصه مالی */}
      <div className="row g-3 mb-4">
        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm h-100 text-center">
            <div className="card-body">
              <p className="text-muted mb-1">Gross Margin</p>
              <h3 className="fw-bold text-success">{data.grossMargin}%</h3>
              <small className="text-secondary">Overall Profitability</small>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm h-100 text-center">
            <div className="card-body">
              <p className="text-muted mb-1">Canceled Orders</p>
              <h3 className="fw-bold text-danger">{data.canceledOrders.count}</h3>
              <small className="text-danger">
                -${data.canceledOrders.revenueLoss} loss
              </small>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm h-100 text-center">
            <div className="card-body">
              <p className="text-muted mb-1">Returned Orders</p>
              <h3 className="fw-bold text-warning">{data.returnedOrders.count}</h3>
              <small className="text-danger">
                -${data.returnedOrders.revenueLoss} loss
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* روش‌های پرداخت */}
      <div className="row g-4">
        <div className="col-12 col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h5 className="fw-semibold mb-3">Payments by Method</h5>
              {data.paymentsByMethod.length === 0 ? (
                <p className="text-muted">No payment data available.</p>
              ) : (
                <div style={{ width: "100%", height: 300 }}>
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie
                        data={data.paymentsByMethod.map((p) => ({
                          name: p._id || "Unknown",
                          value: p.amount,
                        }))}
                        cx="50%"
                        cy="50%"
                        outerRadius={100}
                        label
                        dataKey="value"
                      >
                        {data.paymentsByMethod.map((_, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* جدول جزئیات پرداخت */}
        <div className="col-12 col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h5 className="fw-semibold mb-3">Payment Summary</h5>
              <div className="table-responsive">
                <table className="table table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Method</th>
                      <th>Count</th>
                      <th>Amount ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.paymentsByMethod.map((p) => (
                      <tr key={p._id}>
                        <td>{p._id || "Unknown"}</td>
                        <td>{p.count}</td>
                        <td>{p.amount.toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finance;
